import { render } from "./BeautyWomanPage.vue?vue&type=template&id=207e33f4&scoped=true"
import script from "./BeautyWomanPage.vue?vue&type=script&lang=js"
export * from "./BeautyWomanPage.vue?vue&type=script&lang=js"

import "./BeautyWomanPage.vue?vue&type=style&index=0&id=207e33f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207e33f4"]])

export default __exports__